import React, { Component, useContext } from 'react';
import Booking from '@solvhealth/types/interfaces/Booking';
import Location from '@solvhealth/types/interfaces/Location';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module '../AddReview.css' or its corre... Remove this comment to see the full error message
import s from '../AddReview.css';
import withStyles from '../../../core/isomorphic-style-loader/withStyles';
import NpsCollectionStep from '../steps/NpsCollector';
import AskIfHaveGoogleAccount from '../steps/AskIfHaveGoogleAccount';
import ThankYou from '../steps/ThankYou';
import LeaveReviewOnSolv from '../steps/ReviewOnSolvCollector';
import { NPS_AND_ADD_REVIEW_FLOW_RECOMMEND_TO_GOOGLE } from '../../../constants/index';
import { ReviewContext } from '~/routes/addReview/context';

const NpsAndRecommendToGoogle = () => {
  const context = useContext(ReviewContext)!;

  const {
    booking,
    bookingId,
    error,
    flowState,
    googleUrl,
    handleRatingChange,
    isSubmitting,
    leaveAReview,
    location,
    onStarChange,
    review,
    setFlowState,
    starRating,
    submitReview,
    submitNps,
  } = context;

  return (
    <div>
      <NpsCollectionStep
        booking={booking}
        bookingId={bookingId}
        error={error}
        flowState={flowState}
        handleRatingChange={handleRatingChange}
        location={location}
        onStarChange={onStarChange}
        review={review}
        setFlowState={setFlowState}
        submitNps={submitNps}
        submitReview={submitReview}
      />

      <AskIfHaveGoogleAccount
        booking={booking}
        bookingId={bookingId}
        error={error}
        flowState={flowState}
        googleUrl={googleUrl}
        handleRatingChange={handleRatingChange}
        isSubmitting={isSubmitting}
        leaveAReview={leaveAReview}
        location={location}
        review={review}
        setFlowState={setFlowState}
        starRating={starRating}
        submitReview={submitReview}
      />

      <LeaveReviewOnSolv
        booking={booking}
        bookingId={bookingId}
        error={error}
        flowState={flowState}
        flowType={NPS_AND_ADD_REVIEW_FLOW_RECOMMEND_TO_GOOGLE}
        handleRatingChange={handleRatingChange}
        leaveAReview={leaveAReview}
        location={location}
        onStarChange={onStarChange}
        submitReview={submitReview}
      />

      <ThankYou
        booking={booking}
        bookingId={bookingId}
        flowState={flowState}
        starRating={starRating}
      />
    </div>
  );
};

export default withStyles(s)(NpsAndRecommendToGoogle);
